import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SpecialSystemGuard = createFeatureGuard(Feature.SpecialSystem);